import { pickDevice } from 'console/redux/main-actions';
import { set_ui_settings } from 'console/redux/settings-actions';
export const activateZTHDashboard = () => (dispatch) => {
    dispatch({ type: 'ZTH_DASHBOARD_ACTIVATE' });
    dispatch(set_ui_settings({ zth_dashboard_active: true }));
    dispatch(pickDevice(null));
};
export const deActivateZTHDashboard = () => (dispatch) => {
    dispatch({ type: 'ZTH_DASHBOARD_DEACTIVATE' });
    dispatch(set_ui_settings({ zth_dashboard_active: false }));
};
export function selectZthDashboardEnabled(state) {
    return state.account.zth_dashboard.show;
}
export function selectZthDashboardActive(state) {
    return selectZthDashboardEnabled(state) && state.zth_dashboard.active;
}
